import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../../config/api';

export const useVerifyToken = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const verifyToken = async (token: string, password: string) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await apiClient.post('/users/verify-email', {
        token,
        password,
      });

      if (response.status === 200) {
        setSuccess(true);
        // Redirigir al login después de 3 segundos
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 3000);
      }
    } catch (err: any) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else if (err.response?.status === 400) {
        setError('Token inválido o expirado');
      } else if (err.response?.status === 404) {
        setError('Token no encontrado');
      } else {
        setError('Error al verificar la cuenta. Por favor, intenta de nuevo.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return { verifyToken, isLoading, error, success };
};
